module.exports = __webpack_public_path__ + "static/media/je.62999e4b.svg";